import isNumber from 'lodash/isNumber';

// Truncates number to given number of places without rounding
// https://1loc.dev/number/truncate-a-number-to-a-given-number-of-decimal-places-without-rounding/
export const toFixedWithoutRounding = (n: number, fixed: number): number => {
    return +(
        `${n}`.match(new RegExp(`^-?\\d+(?:.\\d{0,${fixed}})?`)) as string[]
    )[0];
};

export const getValueAsNumber = (value: string | number | null) => {
    if (!value) {
        return null;
    }

    if (isNumber(value)) {
        return value;
    }

    const trimmedValueWithRemovedNonDigits = value.trim().replace(/\D/g, '');
    return Number(trimmedValueWithRemovedNonDigits);
};
